/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const InsertMathIcon = /*#__PURE__*/ createSvgIcon(
  'InsertMathIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10.292 10L6.27 6.062a1.054 1.054 0 01-.198-.3A.855.855 0 016 5.417v-.518c0-.254.086-.468.258-.64A.865.865 0 016.896 4H13c.278 0 .514.097.708.292.195.194.292.43.292.708a.964.964 0 01-.292.708A.964.964 0 0113 6H8.833l3.48 3.48c.152.152.229.326.229.52a.718.718 0 01-.23.52L8.834 14H13c.278 0 .514.097.708.292.195.194.292.43.292.708a.964.964 0 01-.292.708A.964.964 0 0113 16H6.646a.618.618 0 01-.457-.192.633.633 0 01-.189-.462v-.857a.604.604 0 01.188-.469L10.291 10z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default InsertMathIcon;
